import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { Inject } from 'inversify-props'
import { VendaServiceAdapter } from './adapter'
import { VendaModule } from '@/store/vuex/venda/VendaStore'
import { criarVendaDoPdv } from '@/shareds/venda-shareds'
import { ItemDaVenda, NotaDaVenda } from "@/models"
import { CancelarVendaUseCase } from './CancelarVendaUseCase'

export class ReabrirVendaUseCase {
	@Inject('VendaServiceAdapter')
	private vendaService!: VendaServiceAdapter
	private cancelarVendaUseCase!: CancelarVendaUseCase

	constructor() {
		this.cancelarVendaUseCase = new CancelarVendaUseCase()
	}

	async reabrir(identificador: string) {
		try {
			const page = await this.vendaService.find({
				identificador,
			})
			const vendaOriginal = page.content[0]

			if (!vendaOriginal) throw new Error('Venda não encontrada')
			if (!vendaOriginal.pontoDeVenda) throw new Error('Venda não tem ponto de venda')
			if (vendaOriginal.temDevolucao && vendaOriginal.tipoDeTransacao == 'Devolução') throw new Error('Essa venda foi devolvida')
			if (this.existeNotaEmitida(vendaOriginal.notas)) throw new Error('Essa venda não pode ser recuperada. Possui Nota Fiscal emitida')
			//if (vendaOriginal.situacao === 'Cancelada') throw new Error('Essa venda já está cancelada')

			const novoIdentificador = await this.vendaService.gerarIdentificadorDeVenda(vendaOriginal.pontoDeVenda.id)

			if (vendaOriginal.situacao !== 'Cancelada') {
				try {
					await this.cancelarVendaUseCase
						.cancelar(vendaOriginal.id, null)
				} catch (error) {
					VendaModule.iniciarNovaVenda({ identificador: novoIdentificador })
					throw error
				}
			}

			const novaVenda = criarVendaDoPdv(vendaOriginal.pontoDeVenda)
			novaVenda.cpfDoCliente = vendaOriginal.cpfDoCliente
			novaVenda.cliente = vendaOriginal.cliente
			novaVenda.tipoDeCliente = vendaOriginal.tipoDeCliente
			novaVenda.itens = vendaOriginal.itens.map<ItemDaVenda>(item => ({
				id: '',
				desconto: item.desconto,
				quantidade: item.quantidade,
				preco: item.preco,
				precoDeCusto: item.precoDeCusto,
				produto: item.produto,
				idConjunto: item.idConjunto,
				descontoVarejo: item.descontoVarejo,
				percentualCashback: 0,
				diasParaEfetivarCashback: 0,
				valorDescontoRateadoDoItem: 0,
				idItemOrigem: '',
			}))
			novaVenda.desconto = vendaOriginal.desconto
			novaVenda.vendaOrigem = vendaOriginal.vendaOrigem
			novaVenda.tipoDeTransacao = vendaOriginal.tipoDeTransacao
			novaVenda.temDevolucao = vendaOriginal.temDevolucao
			novaVenda.duplicadoDe = {
				id: vendaOriginal.id,
				identificador: vendaOriginal.identificador,
			}

			VendaModule.iniciarNovaVenda({ identificador: novoIdentificador, novaVenda })

		} catch (e) {
			AlertModule.setError(e)
			throw e
		}

	}

	existeNotaEmitida(notas: NotaDaVenda[]) {
		const notasEmitidas = notas.filter(notaFiscal => notaFiscal.cstat === '100')
		return notasEmitidas.length > 0
	}
}